import { Component } from '@angular/core';

import {
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexTitleSubtitle,
  ApexStroke,
  ApexGrid,
  ApexAnnotations,
  ApexLegend,
  ApexMarkers
} from 'ng-apexcharts';
import { Subscription } from 'rxjs';
import {
  ISalesEmployBusinessChartSetting,
  TBranchStoreUsersStatistics
} from './sales-employ-business.interfaces';
import { SalesEmployBusinessChartService } from './sales-employ-business.service';

export type ChartOptions = {
  series: ApexAxisChartSeries;
  annotations: ApexAnnotations;
  chart: ApexChart;
  xaxis: ApexXAxis;
  yaxis: ApexXAxis;
  dataLabels: ApexDataLabels;
  grid: ApexGrid;
  labels: string[];
  stroke: ApexStroke;
  title: ApexTitleSubtitle;
  colors: string[];
  legend: ApexLegend;
  markers: ApexMarkers;
};

@Component({
  selector: 'pg-sales-employ-business',
  templateUrl: './sales-employ-business.component.html'
})
export class SalesEmployBusinessChartComponent {
  dataSubscription$: Subscription;
  data: TBranchStoreUsersStatistics;
  keys: string[];
  selectedValue: string;
  monthTitle = '';

  chartSettings = {} as ISalesEmployBusinessChartSetting;

  constructor(
    private salesEmplyBusinessService: SalesEmployBusinessChartService
  ) {}

  ngOnInit() {
    this.chartSettings.chartTitle =
      'Ventas diaras del mes por local y vendedor';
    this.chartSettings.x_title = 'Días';
    this.chartSettings.y_title = 'Ventas';
    this.chartSettings.formatter = (label) => 'S/.' + label;
    this.chartSettings.dataSelected = undefined;

    this.dataSubscription$ = this.salesEmplyBusinessService
      .getData$()
      .subscribe((data: any) => {
        this.chartSettings.categories = data['days'];
        this.monthTitle = data['month'];

        this.keys = Object.keys(data['statistics']);
        this.selectedValue = this.keys[0];
        this.data = data['statistics'];

        this.chartSettings.dataSelected =
          this.salesEmplyBusinessService.getRefactoredStatisticsForChart(
            this.data[this.selectedValue]
          );
      });
  }

  onSelectedBranchStore(event) {
    this.chartSettings.dataSelected =
      this.salesEmplyBusinessService.getRefactoredStatisticsForChart(
        this.data[this.selectedValue]
      );
  }

  ngOnDestroy() {
    this.dataSubscription$.unsubscribe();
  }
}
